export enum SelectPlanScreen {
  PRODUCT = "PRODUCT_SCREEN",
  PLAN = "PLAN_SCREEN",
  ADD_ON = "ADD_ON",
  ALLOWANCE = "ALLOWANCE"
}